import type { Dispatch, SetStateAction } from "react";

export type PagingAction = { kind: "PagingAction/paged"; page: number };

export function usePagingActions({
  query,
  setPaged,
}: {
  query: string;
  setPaged: Dispatch<SetStateAction<{ query: string; page: number }>>;
}): (action: PagingAction) => void {
  return (action) => {
    switch (action.kind) {
      case "PagingAction/paged": {
        return setPaged({ query, page: action.page });
      }
      default: {
        return action.kind satisfies never;
      }
    }
  };
}
